import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Groups from "@/pages/Groups";
import Events from "@/pages/Events";
import LiveStream from "@/pages/LiveStream";
import Gallery from "@/pages/Gallery";
import PrayerWall from "@/pages/PrayerWall";
import Contact from "@/pages/Contact";
import Community from "@/pages/Community";
import Blogs from "@/pages/Blogs";
import BlogDetail from "@/pages/BlogDetail";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import AuthCallback from "@/pages/AuthCallback";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import Announcements from "@/pages/Announcements";
import GroupDetail from "@/pages/GroupDetail";
import DailyReadings from "@/pages/DailyReadings";
import { ContentProvider } from "@/lib/ContentContext";

const AppRouter = () => {
    const location = useLocation();
    // Detect session_id in URL fragment synchronously — process BEFORE normal routing.
    if (location.hash && location.hash.includes("session_id=")) {
        return <AuthCallback />;
    }
    return (
        <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            {/* /mass route removed, Mass Times now anchor on homepage. Legacy links redirect. */}
            <Route path="/mass" element={<Navigate to="/#mass-times" replace />} />
            <Route path="/daily-readings" element={<DailyReadings />} />
            <Route path="/groups" element={<Groups />} />
            <Route path="/groups/:slug" element={<GroupDetail />} />
            {/* Legacy SCC route now folded into merged Groups page */}
            <Route path="/scc" element={<Navigate to="/groups" replace />} />
            <Route path="/events" element={<Events />} />
            <Route path="/community" element={<Community />} />
            <Route path="/blogs" element={<Blogs />} />
            <Route path="/blogs/:id" element={<BlogDetail />} />
            <Route path="/live" element={<LiveStream />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/prayer-wall" element={<PrayerWall />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/announcements" element={<Announcements />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/admin/login" element={<AdminLogin />} />
        </Routes>
    );
};

function App() {
    return (
        <div className="App">
            <ContentProvider>
                <BrowserRouter>
                    <Layout>
                        <AppRouter />
                    </Layout>
                </BrowserRouter>
                <Toaster richColors position="top-center" />
            </ContentProvider>
        </div>
    );
}

export default App;
